<mat-dialog-actions align="end" class="content">
    <button mat-button matDialogClose="close" class="btn-close">X</button>
</mat-dialog-actions>

<div class="container">
    <table mat-table class="demo-table" [dataSource]="data.estornoTransaction!">
        <ng-container matColumnDef="nsu">
            <th mat-header-cell *matHeaderCellDef>
                {{'sales.estorno.nsu' | translate}}
            </th>
            <td mat-cell *matCellDef="let element">
                {{element.nsu}}
            </td>
        </ng-container>

        <ng-container matColumnDef="cAut">
            <th mat-header-cell *matHeaderCellDef>
                {{'sales.estorno.cAut' | translate}}
            </th>
            <td mat-cell *matCellDef="let element">
                {{element.cAut}}
            </td>
        </ng-container>

        <ng-container matColumnDef="operator">
            <th mat-header-cell *matHeaderCellDef>
                {{'sales.estorno.operator' | translate}}
            </th>
            <td mat-cell *matCellDef="let element" class="uppercase-first-letter">
                {{nameUser}}
            </td>
        </ng-container>

        <ng-container matColumnDef="value">
            <th mat-header-cell *matHeaderCellDef>
                {{'sales.estorno.value' | translate}}
            </th>
            <td mat-cell *matCellDef="let element">
                {{element.total | moneyFormatPipe}}
            </td>
        </ng-container>

        <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>
                {{'sales.estorno.date' | translate}}
            </th>
            <td mat-cell *matCellDef="let element">
                {{element.date | DateTimeFormatPipe}}
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="row-height"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="row-height"></tr>

    </table>
</div>